/**
 * Tờ "Mã QR mở SAPA" (docs/plans/qr-sapa-va-nut-phan-hoi.md, mục 4.1): QR trang chủ SAPA có logo giữa.
 *
 * - Ảnh luôn là data URL (web quầy `/van-hanh` không cho `blob:`).
 * - Tệp PNG dựng sẵn khi tờ mở; lúc bấm "Chia sẻ" gọi `navigator.share` NGAY, không `await` trước (iOS sẽ mất quyền mở bảng chia sẻ).
 */
import { Copy, Download, Share2 } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import { taiPng, veCanvas } from './MaQr.tsx'
import { dungQrSapa, TRANG_CHU_SAPA } from './qr-sapa.ts'
import { QS } from './text/qr-sapa.ts'
import { T } from './text/vi.ts'
import { ThongBao, To } from './ui.tsx'

export function ToQrSapa({ onDong }: { onDong: () => void }) {
  const { svg } = useMemo(() => dungQrSapa(), [])
  const anhTam = useMemo(() => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`, [svg])
  const [anh, setAnh] = useState<string>(anhTam)
  const [file, setFile] = useState<File | null>(null)
  const [bao, setBao] = useState<{ loai: 'thanh-cong' | 'loi'; chu: string } | null>(null)

  useEffect(() => {
    let huy = false
    void veCanvas(svg)
      .then((canvas) => {
        if (huy || canvas === null) return
        setAnh(canvas.toDataURL('image/png'))
        canvas.toBlob((blob) => {
          if (!huy && blob !== null) setFile(new File([blob], QS.tenTep, { type: 'image/png' }))
        }, 'image/png')
      })
      .catch(() => undefined)
    return () => {
      huy = true
    }
  }, [svg])

  const coChiaSe = typeof navigator.share === 'function'

  function chiaSe() {
    // Đồng bộ tới tận `navigator.share` (không await/then trước đó).
    const kemAnh = file !== null && navigator.canShare?.({ files: [file] }) === true
    const loi = (e: unknown) => {
      if (e instanceof DOMException && e.name === 'AbortError') return
      setBao({ loai: 'loi', chu: QS.chiaSeLoi })
    }
    try {
      const p = navigator.share(
        kemAnh
          ? { title: QS.tieuDe, text: QS.chuChiaSe(TRANG_CHU_SAPA), files: [file] }
          : { title: QS.tieuDe, text: QS.chuChiaSe(TRANG_CHU_SAPA), url: TRANG_CHU_SAPA },
      )
      p.catch(loi)
    } catch (e) {
      loi(e)
    }
  }

  function tai() {
    void taiPng(svg, QS.tenTep).catch(() => setBao({ loai: 'loi', chu: QS.chiaSeLoi }))
  }

  async function chep() {
    try {
      await navigator.clipboard.writeText(TRANG_CHU_SAPA)
      setBao({ loai: 'thanh-cong', chu: QS.daChep })
    } catch {
      setBao({ loai: 'loi', chu: QS.chepLoi })
    }
  }

  return (
    <To nhan={QS.tieuDe} onDong={onDong}>
      <div className="to-than qr-sapa">
        <h2>{QS.tieuDe}</h2>
        <p className="chu-phu">{QS.goiY}</p>
        <img className="qr-sapa-anh" src={anh} alt={QS.anhMoTa} />
        <p className="qr-sapa-dia-chi">{QS.diaChi}</p>
        <div className="qr-sapa-nut">
          {coChiaSe ? (
            <>
              <button type="button" className="nut nut-chinh nut-rong" onClick={chiaSe}>
                <Share2 size={18} />
                {QS.chiaSe}
              </button>
              <button type="button" className="nut nut-vien nut-rong" onClick={tai}>
                <Download size={18} />
                {QS.taiAnh}
              </button>
            </>
          ) : (
            <>
              <button type="button" className="nut nut-chinh nut-rong" onClick={tai}>
                <Download size={18} />
                {QS.taiAnh}
              </button>
              <button type="button" className="nut nut-vien nut-rong" onClick={() => void chep()}>
                <Copy size={18} />
                {QS.chep}
              </button>
            </>
          )}
        </div>
        {bao !== null && (
          <ThongBao loai={bao.loai} lon onDong={() => setBao(null)}>
            {bao.chu}
          </ThongBao>
        )}
      </div>
      <div className="to-chan">
        <button type="button" className="nut nut-vien nut-rong" onClick={onDong}>
          {T.close}
        </button>
      </div>
    </To>
  )
}
